// extracted by mini-css-extract-plugin
export default {"selectionBtn":"src-pages-Stock-Detail-StockProductSelection-css__selectionBtn--nxjP4"};